import { render } from "./BottomFixedButton.vue?vue&type=template&id=7988f103"
import script from "./BottomFixedButton.vue?vue&type=script&lang=js"
export * from "./BottomFixedButton.vue?vue&type=script&lang=js"

import "./BottomFixedButton.vue?vue&type=style&index=0&id=7988f103&lang=css"
script.render = render

export default script